module.exports = __webpack_public_path__ + "img/TeamComic_049.fa076a31.png";